import React from "react";
import { SectionHeader } from "../components/section-header";
import { Mail } from "lucide-react";
import { NewsletterSignup } from "@/components/features/newsletter/newsletter-signup";

interface NewsletterSectionProps {}

export function NewsletterSection() {
  return (
    <section className="border-b border-border" aria-labelledby="newsletter-heading">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:py-28">
        <div className="max-w-lg mx-auto text-center">
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-2xl bg-neutral-100 mb-8">
            <Mail className="h-6 w-6 text-foreground" />
          </div>
          <h2 id="newsletter-heading" className="font-display text-2xl font-semibold tracking-tight text-foreground">
            Stay informed
          </h2>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-sm mx-auto">
            Weekly insights on HR strategy, compliance, and workplace culture. Join 2M+ professionals. No noise.
          </p>
          <NewsletterSignup />
        </div>
      </div>
    </section>
  );
}